import React, { Component } from 'react';
import { getBoardingStatusSummary as fetchBoardingStatusSummary } from './boardingStatusSummaryActions';
import { getIsBoardingStatusSummaryLoading, getBoardingStatusSummary } from './boardingStatusSummaryEntity';
import { refreshLeadToLive } from '../LeadToLive/leadToLiveActions';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './BoardingStatusSummaryWidget.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import BoardingStatusSummaryWidgetLegacy from './BoardingStatusSummaryWidgetLegacy';

export const BOARDING_STATUSES = [
    'Pre-Vet',
    'Application Created',
    'Application Sent',
    'Application Received',
    'Underwriting',
    'Pending',
    'Underwritten',
    'Declined',
    'Boarded',
    'Live',
    'Inactive',
    'Closed'
];

const STATUS_BORDER_COLORS = {
    'Pre-Vet': '#005486',
    'Application Created': '#CD8E42',
    'Application Sent': '#117FD3',
    'Application Received': '#008000',
    'Underwriting': '#714CA1',
    'Pending': '#EE8D12',
    'Underwritten': '#6537EC',
    'Declined': '#CF3C2B',
    'Boarded': '#0099BE',
    'Live': '#109E10',
    'Inactive': '#808080',
    'Closed': '#E26500'
};

// use this map to determine which table/tab to sort by when clicking on a status card in Path To Live page
export const STATUS_TO_TABLE_SORT_MAP = {
    'Pre-Vet': 'prevet',
    'Application Created': 'applications',
    'Application Sent': 'applications',
    'Application Received': 'applications',
    'Underwriting': 'applications',
    'Pending': 'applications',
    'Underwritten': 'applications',
    'Declined': 'applications',
    'Boarded': 'merchants',
    'Live': 'merchants',
    'Inactive': 'merchants',
    'Closed': 'merchants'
};

const boardingStatusSummaryShape = PropTypes.shape({
    prevet: PropTypes.number,
    applicationCreated: PropTypes.number,
    applicationSent: PropTypes.number,
    applicationReceived: PropTypes.number,
    underwriting: PropTypes.number,
    pending: PropTypes.number,
    underwritten: PropTypes.number,
    declined: PropTypes.number,
    boarded: PropTypes.number,
    live: PropTypes.number,
    inactive: PropTypes.number,
    closed: PropTypes.number
});

export class BoardingStatusSummaryWidget extends Component {
    static propTypes = {
        history: PropTypes.any,
        boardingStatusSummary: boardingStatusSummaryShape,
        onGetBoardingStatusSummary: PropTypes.func,
        onRefreshLeadToLive: PropTypes.func,
        isLoading: PropTypes.bool,
        setFilter: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.hasAttemptedFetch = false;
    }

    componentDidMount() {
        this.triggerRefresh();
    }

    componentDidUpdate(prevProps) {
        const flagsWereNotReady = !prevProps.flags?.resellerPhase1;
        const flagsAreNowReady = this.props.flags?.resellerPhase1;

        if (flagsWereNotReady && flagsAreNowReady && !this.hasAttemptedFetch) {
            this.triggerRefresh();
        }
    }

    triggerRefresh = () => {
        if (this.props.onRefreshLeadToLive) {
            this.props.onRefreshLeadToLive();
        }
        this.props.onGetBoardingStatusSummary();
        this.hasAttemptedFetch = true;
    };

    boardingStatusCardOnClick = (status) => {
        const targetTab = STATUS_TO_TABLE_SORT_MAP[status];

        this.props.history.push(`/pathToLive?tab=${targetTab}&status=${encodeURIComponent(status)}`);

        if (_.has(this.props, 'setFilter')) {
            this.props.setFilter(status);
        }
    };

    renderCards = () => {
        const arrayMid = _.ceil(BOARDING_STATUSES.length / 2);
        const row1Statuses = _.slice(BOARDING_STATUSES, 0, arrayMid);
        const row2Statuses = _.slice(BOARDING_STATUSES, arrayMid);

        return <div className="boarding-status-summary-cards">
            {_.map([row1Statuses, row2Statuses], (row, index) => {
                return <div className="boarding-status-summary-row" key={`${index}-${row.join(',')}`}>
                    {_.map(row, (boardingStatus) => this.renderCard(boardingStatus))}
                </div>;
            })}
        </div>;
    };

    renderCard = (boardingStatus) => {
        const dataName = boardingStatus === 'Pre-Vet' ? 'Prevet' : boardingStatus;
        const borderColor = STATUS_BORDER_COLORS[boardingStatus];

        const searchParams = new URLSearchParams(this.props.location.search);
        const currentStatus = searchParams.get('status');
        const isActive = currentStatus === boardingStatus;

        return (
            <div
                className="boarding-status-card"
                style={{
                    borderColor,
                    backgroundColor: isActive ? borderColor : '#FFFFFF',
                    color: isActive ? '#ffffff' : '#000000'
                }}
                onClick={() => this.boardingStatusCardOnClick(boardingStatus)}
                key={boardingStatus}
            >
                <div className="boarding-status-text">
                    {boardingStatus}
                </div>
                <div className="boarding-status-value">
                    {
                        this.props.isLoading ?
                            '--'
                            : _.get(this.props.boardingStatusSummary, _.camelCase(dataName), '--')
                    }
                </div>
            </div>
        );
    };

    render() {
        return this.props.flags?.resellerPhase1 ? (
            <div className="boarding-status-summary-widget">
                {this.renderCards()}
            </div>
        ) : (
            <BoardingStatusSummaryWidgetLegacy />
        );
    }
}

export function mapStateToProps(state) {
    return {
        isLoading: getIsBoardingStatusSummaryLoading(state),
        boardingStatusSummary: getBoardingStatusSummary(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onGetBoardingStatusSummary: () => dispatch(fetchBoardingStatusSummary()),
        onRefreshLeadToLive: () => dispatch(refreshLeadToLive())
    };
}

export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(BoardingStatusSummaryWidget)));

